import { render, staticRenderFns } from "./TemplateDataPopover.vue?vue&type=template&id=14b3af62&"
import script from "./TemplateDataPopover.vue?vue&type=script&lang=js&"
export * from "./TemplateDataPopover.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDataPopover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports